import SnapGridRowInterface from './SnapGridRowInterface';
import merge from 'lodash-es/merge';
import first from 'lodash-es/first';
import isObject from 'lodash-es/isObject';

export default class {
    static __larasnap_type = 'snapgrid';

    constructor(component) {
        this._component = component;
    }

    clickRow(params) {
        this._component.clickRow(params);
    }

    clickRowAtPosition(params) {
        this._component.clickRowAtPosition(params);
    }

    setHeight(height) {
        this._component.setHeight(height);
    }

    getRow(params) {
        return new SnapGridRowInterface(this._component.getRow(params));
    }

    getRowByPosition(params) {
        return new SnapGridRowInterface(
            this._component.getRowByPosition(params),
        );
    }

    getCheckedRows() {
        return this._component.getCheckedRows().map(row => {
            return new SnapGridRowInterface(row);
        });
    }

    getCheckedRow() {
        return first(this.getCheckedRows());
    }

    getCheckedRowId() {
        return first(this.getCheckedRowIds());
    }

    getCheckedRowIds() {
        return this._component.getCheckedRowIds();
    }

    getContextMenuOptions(name = null) {
        if (name) {
            return this._component.data.config.context_menu_options.find(
                x => x.name === name,
            );
        } else {
            return this._component.data.config.context_menu_options;
        }
    }

    setContextMenuOptions(param) {
        if (Array.isArray(param)) {
            param.forEach(option => {
                this.setContextMenuOptions(option);
            });
        } else if (isObject(param)) {
            const option = this.getContextMenuOptions(param.name);
            if (option) {
                merge(option, param);
            } else {
                this._component.data.config.context_menu_options.push(param);
            }
        }
    }

    setLoadPanelButtonLabel(val) {
        this._component.config.buttons.forEach(button => {
            if (button.type === 'addButton') {
                button.label = val;
                return false;
            }
        });
    }

    /****************************************************************************************/
    //                                     Events
    /****************************************************************************************/

    /* eslint-disable no-unused-vars */
    contextMenuShow(row) {}

    /* eslint-disable no-unused-vars */
    contextMenuOptionSelected(option) {}

    /****************************************************************************************/
    //                                Support / Utilities
    /****************************************************************************************/

    getWrapper() {
        return this._component.getElement('wrapper');
    }

    find(selector) {
        return $(this.getWrapper()).find(selector);
    }

    getComponent() {
        return this._component;
    }

    bind(type, name, data) {
        return this._component.bind(type, name, data);
    }

    unbind(type, name, data) {
        return this._component.unbind(type, name, data);
    }

    getProps(key) {
        return this._component.getProps(key);
    }

    getFilter(name) {
        return this.getProps().filters.find(
            filter => filter.name.toLowerCase() === name.toLowerCase(),
        );
    }

    addHandler(event, func) {
        return this._component.addHandler(event, func);
    }

    reload(...params) {
        return this._component.reload(...params);
    }

    clearCheckedRows() {
        return this._component.clearCheckedRows();
    }

    emit(event, ...params) {
        this._component.$emit(event, ...params);
    }
}
